// src/pages/Dictionary.jsx - Redesigned with Modern Orange-to-Pink Theme
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import SearchNavigation from '../components/SearchNavigation';
import ApiService from '../services/apiService';

const Dictionary = () => {
  const navigate = useNavigate();
  const [blogPosts, setBlogPosts] = useState([]);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [isLoadingCourts, setIsLoadingCourts] = useState(true);
  const [courtsError, setCourtsError] = useState('');
  const [defination, setdefination] = useState([]);
  const [isLoadingJudgements, setIsLoadingJudgements] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    loadCourts();
  }, []);

  // Load courts from API
  const loadCourts = async () => {
    try {
      setIsLoadingCourts(true);
      setSelectedCourt('A vinculo matrimonii');
      const apiResponse = await ApiService.getDics();
      setBlogPosts(apiResponse || []);
      loadJudgements('A vinculo matrimonii');
    } catch (error) {
      console.error('❌ Error loading dictionary:', error);
      setCourtsError(error.message || 'Failed to load dictionary');
    } finally {
      setIsLoadingCourts(false);
    }
  };

  // Load definition for selected word
  const loadJudgements = async (courtKey) => {
    setIsLoadingJudgements(true);
    try {
      const apiResponse = await ApiService.getDefination(courtKey);
      setdefination(apiResponse || []);
    } catch (error) {
      console.error('Error loading definition:', error);
    } finally {
      setIsLoadingJudgements(false);
    }
  };

  const handleCourtSelect = (courtKey) => {
    setSelectedCourt(courtKey);
    loadJudgements(courtKey);
  };

  const filteredItems = blogPosts.filter(item =>
    item.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="dictionary-layout">
      <Navbar />
      <SearchNavigation />

      <div className="dictionary-main-content">
        {/* Hero Section */}
        <div className="dictionary-hero">
          <div className="hero-badge">
            <i className="bx bx-book-open"></i>
            <span>Legal Dictionary</span>
          </div>
          <h1 className="hero-title">
            Legal Terms & Definitions
          </h1>
          <p className="hero-subtitle">
            Comprehensive dictionary of legal terminology
          </p>
        </div>

        <div className="dictionary-container">
          <div className="dictionary-grid">
            {/* Left Sidebar - Words List */}
            <div className="words-sidebar">
              <div className="sidebar-header">
                <div className="header-icon">
                  <i className="bx bx-list-ul"></i>
                </div>
                <div className="header-content">
                  <h3 className="sidebar-title">Terms</h3>
                  <p className="sidebar-subtitle">{filteredItems.length} word{filteredItems.length !== 1 ? 's' : ''}</p>
                </div>
              </div>

              {/* Search Box */}
              <div className="search-box">
                <i className="bx bx-search search-icon"></i>
                <input
                  type="text"
                  className="search-input"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search terms..."
                />
                {searchText && (
                  <button
                    className="clear-search"
                    onClick={() => setSearchText('')}
                  >
                    <i className="bx bx-x"></i>
                  </button>
                )}
              </div>

              <div className="sidebar-body">
                {isLoadingCourts ? (
                  <div className="loading-state">
                    <i className="bx bx-loader-alt bx-spin"></i>
                    <p>Loading dictionary...</p>
                  </div>
                ) : courtsError ? (
                  <div className="error-state">
                    <i className="bx bx-error-circle"></i>
                    <p>{courtsError}</p>
                  </div>
                ) : filteredItems.length === 0 ? (
                  <div className="empty-state">
                    <i className="bx bx-search-alt"></i>
                    <p>No terms found matching "{searchText}"</p>
                  </div>
                ) : (
                  <div className="words-list">
                    {filteredItems.map((state, idx) => (
                      <div
                        key={idx}
                        className={`word-item ${selectedCourt === state ? 'active' : ''}`}
                        onClick={() => handleCourtSelect(state)}
                      >
                        <div className="word-icon">
                          <i className="bx bx-book-bookmark"></i>
                        </div>
                        <div className="word-text">
                          <span className="word-name">{state}</span>
                        </div>
                        <div className="word-arrow">
                          <i className="bx bx-chevron-right"></i>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Right Content - Definition */}
            <div className="definition-content">
              <div className="content-header">
                <div className="header-info">
                  <div className="term-badge">
                    <i className="bx bx-tag"></i>
                    <span>Term</span>
                  </div>
                  <h3 className="content-title">
                    {selectedCourt ? selectedCourt : 'Select a term'}
                  </h3>
                </div>
              </div>

              <div className="content-body">
                {isLoadingJudgements ? (
                  <div className="loading-definition">
                    <i className="bx bx-loader-alt bx-spin"></i>
                    <p>Loading definition...</p>
                  </div>
                ) : defination.length === 0 ? (
                  <div className="empty-definition">
                    <i className="bx bx-info-circle"></i>
                    <p>No definition available for this term</p>
                  </div>
                ) : (
                  <div className="definition-card">
                    <div className="definition-header">
                      <i className="bx bx-book-reader"></i>
                      <h4>Definition</h4>
                    </div>
                    <div className="definition-body">
                      {defination.map((state, idx) => (
                        <div key={idx} className="definition-paragraph">
                          <div className="paragraph-marker">
                            <i className="bx bx-right-arrow-alt"></i>
                          </div>
                          <p>{state}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        /* ============================================
           BASE LAYOUT
        ============================================ */
        .dictionary-layout {
          min-height: 100vh;
          background: #fafafa;
        }

        .dictionary-main-content {
          padding-top: 140px;
          width: 100%;
        }

        /* ============================================
           HERO SECTION
        ============================================ */
        .dictionary-hero {
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 25%, #c41849 75%, #D81B60 100%);
          padding: 50px 20px 40px;
          text-align: center;
          color: white;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 20px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 50px;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .hero-badge i {
          font-size: 16px;
        }

        .hero-title {
          font-size: 2rem;
          font-weight: 800;
          margin: 0 0 10px 0;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          letter-spacing: -0.5px;
          line-height: 1.2;
        }

        .hero-subtitle {
          font-size: 1rem;
          opacity: 0.95;
          margin: 0;
          font-weight: 400;
        }

        /* ============================================
           DICTIONARY CONTAINER
        ============================================ */
        .dictionary-container {
          max-width: 1400px;
          margin: -30px auto 0;
          padding: 0 20px 40px;
          position: relative;
          z-index: 10;
        }

        .dictionary-grid {
          display: grid;
          grid-template-columns: 350px 1fr;
          gap: 20px;
          min-height: 600px;
        }

        /* ============================================
           LEFT SIDEBAR
        ============================================ */
        .words-sidebar {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          height: fit-content;
          max-height: calc(100vh - 200px);
          position: sticky;
          top: 160px;
          display: flex;
          flex-direction: column;
        }

        .sidebar-header {
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.05));
          padding: 20px;
          display: flex;
          align-items: center;
          gap: 14px;
          border-bottom: 2px solid #f5f5f5;
          flex-shrink: 0;
        }

        .header-icon {
          width: 44px;
          height: 44px;
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 22px;
          flex-shrink: 0;
        }

        .header-content {
          flex: 1;
        }

        .sidebar-title {
          font-size: 16px;
          font-weight: 700;
          color: #333;
          margin: 0 0 3px 0;
        }

        .sidebar-subtitle {
          font-size: 12px;
          color: #666;
          margin: 0;
        }

        /* Search Box */
        .search-box {
          position: relative;
          padding: 16px;
          border-bottom: 1px solid #f5f5f5;
          flex-shrink: 0;
        }

        .search-icon {
          position: absolute;
          left: 28px;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
          font-size: 18px;
        }

        .search-input {
          width: 100%;
          padding: 10px 40px 10px 40px;
          border: 2px solid #e0e0e0;
          border-radius: 10px;
          font-size: 14px;
          color: #333;
          background: #fafafa;
          transition: all 0.3s ease;
        }

        .search-input:focus {
          outline: none;
          border-color: #E91E63;
          background: white;
          box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.1);
        }

        .clear-search {
          position: absolute;
          right: 28px;
          top: 50%;
          transform: translateY(-50%);
          width: 24px;
          height: 24px;
          border: none;
          background: #f0f0f0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #666;
          transition: all 0.2s ease;
        }

        .clear-search:hover {
          background: #e0e0e0;
          color: #333;
        }

        .sidebar-body {
          flex: 1;
          overflow-y: auto;
          min-height: 0;
        }

        /* States */
        .loading-state,
        .error-state,
        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          gap: 12px;
        }

        .loading-state i,
        .error-state i,
        .empty-state i {
          font-size: 40px;
          color: #E91E63;
        }

        .error-state i {
          color: #c41849;
        }

        .empty-state i {
          color: #ccc;
        }

        .loading-state p,
        .error-state p,
        .empty-state p {
          font-size: 14px;
          color: #666;
          margin: 0;
          text-align: center;
        }

        /* Words List */
        .words-list {
          padding: 8px;
        }

        .word-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 14px;
          margin-bottom: 6px;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }

        .word-item:hover {
          background: #f8f9fa;
          transform: translateX(4px);
        }

        .word-item.active {
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.05));
          border-color: #c41849;
          box-shadow: 0 2px 10px rgba(233, 30, 99, 0.15);
        }

        .word-icon {
          width: 36px;
          height: 36px;
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.15), rgba(233, 30, 99, 0.1));
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #E91E63;
          font-size: 18px;
          flex-shrink: 0;
        }

        .word-item.active .word-icon {
          background: linear-gradient(135deg, #E91E63, #c41849);
          color: white;
        }

        .word-text {
          flex: 1;
          min-width: 0;
        }

        .word-name {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .word-item.active .word-name {
          color: #c41849;
        }

        .word-arrow {
          color: #ccc;
          font-size: 18px;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .word-item:hover .word-arrow,
        .word-item.active .word-arrow {
          color: #c41849;
          transform: translateX(3px);
        }

        /* Scrollbar */
        .sidebar-body::-webkit-scrollbar {
          width: 5px;
        }

        .sidebar-body::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-radius: 4px;
        }

        /* ============================================
           RIGHT CONTENT
        ============================================ */
        .definition-content {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          display: flex;
          flex-direction: column;
        }

        .content-header {
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.05));
          padding: 24px 28px;
          border-bottom: 2px solid #f5f5f5;
        }

        .header-info {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .term-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 14px;
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.15), rgba(233, 30, 99, 0.1));
          border-radius: 50px;
          font-size: 12px;
          font-weight: 600;
          color: #E91E63;
          width: fit-content;
        }

        .term-badge i {
          font-size: 14px;
        }

        .content-title {
          font-size: 24px;
          font-weight: 700;
          color: #333;
          margin: 0;
          line-height: 1.3;
        }

        .content-body {
          flex: 1;
          overflow: auto;
          padding: 28px;
        }

        /* Definition States */
        .loading-definition,
        .empty-definition {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 80px 20px;
          gap: 15px;
        }

        .loading-definition i,
        .empty-definition i {
          font-size: 60px;
          color: #E91E63;
        }

        .empty-definition i {
          color: #ddd;
        }

        .loading-definition p,
        .empty-definition p {
          font-size: 16px;
          color: #666;
          margin: 0;
        }

        /* Definition Card */
        .definition-card {
          background: #fafafa;
          border-radius: 16px;
          padding: 28px;
          border: 2px solid #f0f0f0;
        }

        .definition-header {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
          padding-bottom: 16px;
          border-bottom: 2px solid #e0e0e0;
        }

        .definition-header i {
          font-size: 24px;
          color: #E91E63;
        }

        .definition-header h4 {
          font-size: 18px;
          font-weight: 700;
          color: #333;
          margin: 0;
        }

        .definition-body {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .definition-paragraph {
          display: flex;
          gap: 12px;
          background: white;
          padding: 16px;
          border-radius: 12px;
          border-left: 3px solid #E91E63;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

        .paragraph-marker {
          width: 24px;
          height: 24px;
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.15), rgba(233, 30, 99, 0.1));
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #E91E63;
          font-size: 16px;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .definition-paragraph p {
          font-size: 15px;
          line-height: 1.7;
          color: #333;
          margin: 0;
          flex: 1;
        }

        /* ============================================
           ANIMATIONS
        ============================================ */
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .bx-spin {
          animation: spin 1s linear infinite;
        }

        /* ============================================
           RESPONSIVE DESIGN
        ============================================ */
        @media (max-width: 1024px) {
          .dictionary-grid {
            grid-template-columns: 300px 1fr;
            gap: 16px;
          }

          .words-sidebar {
            top: 150px;
          }
        }

        @media (max-width: 768px) {
          .dictionary-main-content {
            padding-top: 130px;
          }

          .dictionary-hero {
            padding: 35px 15px 30px;
          }

          .hero-title {
            font-size: 1.6rem;
          }

          .hero-subtitle {
            font-size: 0.95rem;
          }

          .dictionary-container {
            margin-top: -20px;
            padding: 0 15px 30px;
          }

          .dictionary-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .words-sidebar {
            position: relative;
            top: 0;
            max-height: 400px;
          }

          .content-header {
            padding: 20px 22px;
          }

          .content-title {
            font-size: 20px;
          }

          .content-body {
            padding: 22px;
          }

          .definition-card {
            padding: 22px;
          }
        }

        @media (max-width: 480px) {
          .hero-title {
            font-size: 1.4rem;
          }

          .hero-badge {
            padding: 6px 14px;
            font-size: 12px;
          }

          .sidebar-header {
            padding: 16px;
          }

          .header-icon {
            width: 38px;
            height: 38px;
            font-size: 18px;
          }

          .sidebar-title {
            font-size: 14px;
          }

          .search-box {
            padding: 12px;
          }

          .content-header {
            padding: 18px 20px;
          }

          .content-title {
            font-size: 18px;
          }

          .content-body {
            padding: 20px;
          }

          .definition-card {
            padding: 20px;
          }

          .definition-paragraph {
            padding: 14px;
          }

          .definition-paragraph p {
            font-size: 14px;
          }
        }
           /* ============================================
           REMOVE TOP WHITE SPACE
        ============================================ */
        body {
          margin: 0 !important;
          padding: 0 !important;
        }
      `}</style>
    </div>
  );
};

export default Dictionary;